const TASK_STATUS_BADGE_CLASS: Record<string, string> = {
  Pending: 'rpt-badge rpt-badge--pending',
  Assigned: 'rpt-badge rpt-badge--assigned',
  Completed: 'rpt-badge rpt-badge--completed',
  Escalated: 'rpt-badge rpt-badge--escalated',
  Forwarded: 'rpt-badge rpt-badge--forwarded',
  Rejected: 'rpt-badge rpt-badge--rejected',
  Reverted: 'rpt-badge rpt-badge--reverted',
  Draft: 'rpt-badge rpt-badge--draft',
  Submitted: 'rpt-badge rpt-badge--submitted',
  'Pending Assignment': 'rpt-badge rpt-badge--pending',
  'Requested to Re-allocate': 'rpt-badge rpt-badge--reallocate',
};

export function ReportTaskStatusBadge({ status }: { status: string }) {
  const cls = TASK_STATUS_BADGE_CLASS[status] ?? 'rpt-badge rpt-badge--forwarded';
  return <span className={cls}>{status}</span>;
}

export function ReportUrgencyBadge({ level }: { level: string }) {
  const cls =
    level === 'High'
      ? 'rpt-badge rpt-badge--high'
      : level === 'Medium'
        ? 'rpt-badge rpt-badge--medium'
        : 'rpt-badge rpt-badge--low';
  return <span className={cls}>{level}</span>;
}

export function ReportMetric({
  value,
  variant = 'neutral',
}: {
  value: number;
  variant?: 'neutral' | 'blue' | 'red' | 'orange' | 'green' | 'zero';
}) {
  if (value === 0 && variant !== 'neutral') {
    return <span className="rpt-metric rpt-metric--zero">0</span>;
  }
  if (variant === 'green') {
    return <span className="rpt-metric--green">{value}</span>;
  }
  if (variant === 'neutral') {
    return <span className="rpt-metric--neutral">{value}</span>;
  }
  return <span className={`rpt-metric rpt-metric--${variant}`}>{value}</span>;
}
